<template>
  <section class="auth-summer-page bg-no-repeat bg-center bg-cover w-full min-h-[100vh]">
    <div class="auth-summer-wrap w-full relative mx-auto flex justify-between items-start max-w-[1400px]">

      <!--left-->
      <div class="auth-summer-aside pt-[249px] w-[555px]">
        <!--solution-->
        <div class="box-border w-full py-[53px]"> 
          <!--title-->
          <h2 class="mb-[30px] text-[17px] font-bold text-[#080808FF]"><span class="text-[#3C7FFFFF]">{{ $t("signup.adv.s1") }}</span> {{ $t("signup.adv.s2") }}</h2>
          <!--solution list-->
          <ul class="flex w-full">
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("signup.features.f1") }}</span>
              </li>
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("signup.features.f2") }}</span>
              </li>
          </ul>
          <!--solution list-->
          <ul class="flex w-full">
            <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("signup.features.f3") }}</span>
              </li>
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("signup.features.f4") }}</span>
              </li>
          </ul>
        </div>
        <!--follow us-->
        <!-- <div class="follow_us_box">
            <img src="@/assets/index/img/login/proxy_img.webp" alt="">
        </div> -->
      </div> <!-- left end -->

      <!--right-->
      <div class="auth-summer-panel pt-[140px] max-w-[520px] w-full">
        <!--sign up-->
        <div class="auth-summer-card w-full box-border px-[45px] pt-[40px] pb-[44px] m-0 bg-white shadow-xl rounded-[10px]">
          <h6 class="text-[39px] text-center"><img class="w-[41px] h-[41px] max-w-full mr-[15px] inline-block" src="@/assets/logo-square.png"/><span class="text-[#00414a]">{{ $t("signup.title") }}</span></h6>
          <p class="text-[14px] p-0 mt-[30px] mx-auto mb-[39px] w-auto max-w-[620px] font-normal leading-[24px] text-center text-[#223265] tracking-normal">{{ $t("signup.slogan") }}</p>
          
          <el-steps :active="activeStep" simple finish-status="success" class="mb-[10px]">
            <el-step :title="$t('signup.steps.basic')" icon="el-icon-user"></el-step>
            <el-step :title="$t('signup.steps.email')" icon="el-icon-message"></el-step>
            <el-step :title="$t('signup.steps.password')" icon="el-icon-key"></el-step>
          </el-steps>

          <el-form :model="dataForm" :rules="rules" ref="ruleForm" hide-required-asterisk class="min-h-[286px]">
              <el-form-item prop="first_name" v-if="activeStep === 0">
                <label class="w-full leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("signup.fields.first_name") }}</label>
                <el-input v-model="dataForm.first_name" clearable :placeholder="$t('signup.fields.first_name_placeholder')" class="h-[25px] text-[16px] border-none font-normal tracking-normal outline-0 !bg-transparent"></el-input>
              </el-form-item>
              <el-form-item prop="last_name" v-if="activeStep === 0">
                <label class="w-full leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("signup.fields.last_name") }}</label>
                <el-input v-model="dataForm.last_name" clearable :placeholder="$t('signup.fields.last_name_placeholder')" class="h-[25px] text-[16px] border-none font-normal tracking-normal outline-0 !bg-transparent"></el-input>
              </el-form-item>
              <el-form-item v-if="activeStep === 0">
                <label class="w-full leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("signup.fields.country") }}</label>
                <el-select style="width: 100%" v-model="dataForm.country" class="item" :placeholder="$t('signup.fields.country_placeholder')" size="large"
                          suffix-icon="CaretBottom" filterable>
                  <el-option v-for="item in countryList" :key="item.country_code" :label="item.country_name" :value="item.country_code"/>
                </el-select>
              </el-form-item>

              <el-form-item prop="email" v-if="activeStep === 1">
                <label class="w-full leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("signup.fields.email") }}</label>
                <el-input v-model="dataForm.email" clearable :placeholder="$t('signup.fields.email_placeholder')" class="h-[25px] text-[16px] border-none font-normal tracking-normal outline-0 !bg-transparent"></el-input>
              </el-form-item>
              <el-form-item prop="code" v-if="activeStep === 1">
                <label class="w-full leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("signup.fields.verification_code") }}</label>
                <el-input v-model="dataForm.code" :placeholder="$t('signup.fields.verification_code_placeholder')">
                  <el-button class="code-btn" slot="append" v-if="!isDis" @click="handGetCode" :loading="codeLoading">{{ $t("signup.fields.send_code") }}</el-button>
                  <el-button class="code-btn" slot="append" v-else disabled >{{ $t("signup.fields.resend") }}</el-button>
                </el-input>
              </el-form-item>
            
              <el-form-item prop="password" v-if="activeStep === 2">
                <label class="w-max leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("signup.fields.password") }}</label>
                <el-input type="password" v-model="dataForm.password" clearable show-password :placeholder="$t('signup.fields.password_placeholder')" class="h-[25px] text-[16px] border-none font-normal tracking-normal outline-0 !bg-transparent"></el-input>
              </el-form-item>
              <el-form-item prop="confirm_password" v-if="activeStep === 2">
                <label class="w-max leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("signup.fields.confirm_password") }}</label>
                <el-input v-model="dataForm.confirm_password" type="password" show-password :placeholder="$t('signup.fields.confirm_password_placeholder')"></el-input>
              </el-form-item>

              <div v-if="activeStep === 2" class="flex flex-row items-center text-center mt-[20px] text-[12px] align-bottom">
                <el-checkbox v-model="checked" size="medium"></el-checkbox>
                <span class="ml-[10px] text-[#313942cc]" @click="checked=!checked">{{ $t("signup.fields.agreement.text1") }}</span><a @click="open" class="inline-block px-[4px] text-[12px] text-[#2F80ED] no-underline cursor-pointer">{{ $t("signup.fields.agreement.text2") }}</a>
              </div>

              <cfturnstile v-if="activeStep === 0 && sitekey" :sitekey="sitekey" @verify="verify" @fail="onTurnstileFailed"/>
          </el-form>

          <div class="flex flex-row justify-start items-center text-center mt-[20px] text-[16px]">
            <el-button round v-if="activeStep > 0" @click="prev" class="shadow-md px-[30px]">{{ $t("signup.fields.back") }}</el-button>
            <el-button round v-if="activeStep < 2" type="primary" @click="next" class="shadow-md px-[30px]">{{ $t("signup.fields.next") }}</el-button>
            <el-button round v-if="activeStep == 2" type="success" :loading="formLoading" @click="register('ruleForm')" class="shadow-md px-[30px]">{{ $t("signup.fields.action") }}</el-button>
          </div>
          
          <p class="text-[14px] font-normal text-[#a7aab0] mt-[24px] text-center align-baseline">{{ $t("signup.instructions.guide") }} <a href="/login" target="_self" class="text-[#3c7fff] underline" @click.prevent="openLogin">{{ $t("signup.instructions.login") }}</a></p>
        </div>

        <modalPrivacy @agree="checked = true" ref="modalPrivacy"></modalPrivacy>
      </div>

    </div>
  </section>
</template>

<script>
import {getRegion} from '@/http/api/home'
import {checkEmail, signUp, getEmailCode, checkCode} from '@/http/api/member'
import TurnstileWidget from '@/components/turnstile-widget'

import md5 from 'js-md5'
import { cookieAuthEnabled } from '@/http/authMode'
import modalPrivacy from './modalPrivacy'
export default {
  name: 'signup',
    components:{
        modalPrivacy,
        'cfturnstile': TurnstileWidget,
    },
  data() {
    return {
      sitekey: process.env.VUE_APP_SITEKEY,

      activeStep: 0,
      checked:false,
      formLoading:false,
      codeLoading:false,
      isDis:false,
      
      dataForm: {
        email: '',
        password: '',
        confirm_password: '',
        first_name: '',
        last_name: '',
        code: '',
        country: '',
        token: '',
        
      },
      countryList: [],
    }
  },
  inject: ['updateButtons'],
  computed: {
    rules() {
      return {
        email: [
          {required: true, message: this.$t("signup.message.email_required"), trigger: 'blur'},
          { validator: this.handleCheckEmail, trigger: 'blur' },
        ],
        password: [
          {required: true, message: this.$t("signup.message.password_invalid"), trigger: 'blur'},
          {
            min: 8,
            max: 20,
            message: this.$t("signup.message.password_invalid"),
            trigger: 'blur'
          }
        ],
        confirm_password: [
          {required: true, message: this.$t("signup.message.confirm_password_required"), trigger: 'blur'},
        ],
        first_name: [
          {required: true, message: this.$t("signup.message.first_name_required"), trigger: 'blur'},
        ],
        last_name: [
          {required: true, message: this.$t("signup.message.last_name_required"), trigger: 'blur'},
        ],
        code: [
          {required: true, message: this.$t("signup.message.verification_code_required"), trigger: 'blur'},
          { validator: this.handleCheckCode, trigger: 'blur' },
        ]
      }; 
    }
  },
  created() {
    this.getCountry()
  },
  mounted() {
    this.updateButtons(true, false);
  },
  destroyed() {
    this.timers = null
    clearTimeout(this.timers)
  },
  methods: {
    verify(token) {
      this.dataForm.token = token;
    },
    onTurnstileFailed() {
      console.log('Turnstile failed');
    },
    next() {
      // TODO: 增加检查邮箱是否已注册的逻辑
      this.$refs.ruleForm.validate((valid) => {
      if (valid) {
        if (this.activeStep < 2) {
          this.activeStep++;
        }
      }
    });
    },
    prev() {
      if (this.activeStep > 0) {
        this.$refs.ruleForm.clearValidate();
        this.activeStep--;
      }
    },

    open(){
        this.$refs.modalPrivacy.open()
    },
    openLogin(){
      this.$router.push({path:'/login'})
    },
    async handleCheckEmail(rule, value, callback) {
      let self = this;
      if (!value) {
        return callback(new Error(self.$t('signup.message.email_required')));
      }
      await checkEmail({email: value}).then(res => {
        if (res.data.exists) {
          callback(new Error(self.$t('signup.message.email_exists')));
        } else {
          callback();
        }
      }).catch(err => {
        callback(new Error(this.$t('signup.message.request_fail')));
      })      
    },
    handGetCode(){
      if(this.dataForm.email === ''){
        this.$message.error(this.$t("signup.message.email_required"))
        return;
      }
      this.codeLoading = true;
      getEmailCode({email:this.dataForm.email,token:this.dataForm.token, type:"register"}).then(res=>{
        this.codeLoading = false;
        // console.log(res)
        this.isDis = true;
        this.timers = setTimeout(()=>{
          this.isDis = false;
        },60*1000)
      }).catch(err=>{
        this.codeLoading = false;
      })
    },
    async handleCheckCode(rule, value, callback) {
      let self = this;
      if (!value) {
        return callback(new Error(self.$t('signup.message.verification_code_required')));
      }
      if(this.dataForm.email === ''){
        this.$message.error(this.$t("signup.message.email_required"))
        return;
      }

      await checkCode({email:this.dataForm.email, code: value,token:this.dataForm.token}).then(res => {
        if (!res.data.valid) {
          callback(new Error(self.$t('signup.message.code_invalid')));
        } else {
          callback();
        }
      }).catch(err => {
        if (err.data && err.data.code !== 200) {
          callback(new Error(err.data.msg));
        } else {
          callback(new Error(this.$t('signup.message.request_fail')));
        }
      })      
    },
    async getCountry() {
      const res = await getRegion({level: 1});
      // console.log(res)
      this.countryList = res.data || []
    },
    save() {
      this.formLoading = true;
      signUp({
          ...this.dataForm,
          password: cookieAuthEnabled ? this.dataForm.password : md5(this.dataForm.password),
          confirm_password: cookieAuthEnabled
            ? this.dataForm.confirm_password
            : md5(this.dataForm.confirm_password),
      }).then(res => {
        this.formLoading = false;
        // console.log(res)
        if(res.code === 0){
          this.$message.info(res.msg)
        }else{
          this.$message.success(res.msg)

          this.$router.replace({path: '/login', query: {redirect: this.$route.query?.redirect ?? ''}});
        }
      }).catch(err => {
        this.formLoading = false;
        // this.$message.error(e.message ?? e.msg ?? this.$t("signup.message.request_fail"));
      })
    },
    register(formName) {
        if(!this.checked){
            this.$refs.modalPrivacy.open()
            return
        }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-steps--simple {
  background: transparent;
}
</style>
